import { QueryClient } from '@tanstack/react-query';
/**
 * Shared QueryClient for the portal. Tuned for dashboard-style workloads
 * where data rarely changes mid-session but windows may be left open for hours.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30 * 1000, // 30 seconds
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});
